import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import IGetTreeTradeResponse from 'services/httpClient/responses/treeTrade/IGetTreeTradeResponse';

import { treeTradeActions } from '..';

import { IGetTreeTradeRequestAction } from '../reducers/getTreeTrade/request';

function* getTreeTrade(action: PayloadAction<IGetTreeTradeRequestAction>) {
  try {
    const response: AxiosResponse<IGetTreeTradeResponse> = yield call(
      httpClient.get,
      `backoffice/v1/rik_treetrades`,
    );
    yield put(
      treeTradeActions.getTreeTradeSuccess({
        treeTrade: response.data.children,
      }),
    );
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(treeTradeActions.getTreeTradeFailure());
  }
}

export default getTreeTrade;
